var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CrudList',{attrs:{"title":"Notificaciones","storeName":"Push_notifications","canAdd":_vm.user.user_role != 'admin_enterprise',"canEdit":false,"canDelete":true,"role_admin_enterprise":_vm.user.user_role == 'admin_enterprise',"sortable":"","next-link":"/admin/banners","breadcrumbs":[
      {
        text: 'Marketing y comunicación',
        disabled: false,
        href: '/admin/push_notifications'
      },
      {
        text: 'Notificaciones',
        disabled: false,
        href: '#'
      }
    ]},scopedSlots:_vm._u([{key:"title",fn:function({ item }){return [_c('div',{staticClass:"table-cell-fixed"},[_vm._v(" "+_vm._s(item.title)+" ")])]}},{key:"created_at",fn:function({ item }){return [_c('div',{staticClass:"table-cell-fixed"},[_vm._v(" "+_vm._s(_vm.formatDate(item.created_at))+" ")])]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }